import api from "../../api";
import {
  findElementByText,
  formatCurrency,
  normalizeText,
  parseCurrency,
  replaceText,
} from "./domUtils";

let financeSummary = null;
let financeSummaryRequest = null;
let mountedForecastHeading = null;

export const resetFinanceSummary = () => {
  financeSummary = null;
  mountedForecastHeading = null;
};

const loadAuthoritativeFinanceSummary = async () => {
  if (financeSummaryRequest) return financeSummaryRequest;
  financeSummaryRequest = api
    .get("/human-resources/reports/overview")
    .then((response) => {
      financeSummary =
        response?.data?.summary ||
        response?.data?.data?.summary ||
        response?.data ||
        null;
      return financeSummary;
    })
    .catch(() => null)
    .finally(() => {
      financeSummaryRequest = null;
    });
  return financeSummaryRequest;
};

const findForecastCard = (label) => {
  const normalizedLabel = normalizeText(label);
  const labelElement = findElementByText(
    "p",
    (text) => text === normalizedLabel,
  );
  if (!labelElement) return null;
  const card =
    labelElement.closest("div.rounded-2xl") || labelElement.parentElement;
  const values = Array.from(card?.querySelectorAll("p") || []).filter(
    (element) => element !== labelElement,
  );
  return values[values.length - 1] || null;
};

export const applyAuthoritativeFinanceValues = async () => {
  const forecastHeading = findElementByText(
    "h2",
    (text) => text === "previsao de gastos",
  );
  if (!forecastHeading) return;
  if (forecastHeading !== mountedForecastHeading) {
    mountedForecastHeading = forecastHeading;
    financeSummary = null;
  }
  if (!financeSummary) await loadAuthoritativeFinanceSummary();
  if (!financeSummary) return;

  const hrValue = findForecastCard("Custo RH Mensal");
  const benefitsValue = findForecastCard("Custo Benefícios Mensal");
  const manualValue = findForecastCard("Despesas do mês");
  const maintenanceValue = findForecastCard("Manutenções programadas");
  const totalLabel = findElementByText("p", (text) =>
    text.startsWith("total previsto em"),
  );
  const totalValue = totalLabel
    ? Array.from(totalLabel.parentElement?.querySelectorAll("p") || [])
        .filter((element) => element !== totalLabel)
        .pop()
    : null;

  const hrMonthlyCost = Number(financeSummary.hrMonthlyCost || 0);
  const benefitsMonthlyCost = Number(
    financeSummary.benefitsMonthlyCost || 0,
  );
  const manualTotal = parseCurrency(manualValue?.textContent);
  const maintenanceTotal = parseCurrency(maintenanceValue?.textContent);

  // hrMonthlyCost já inclui benefícios no cálculo do backend. O cartão de
  // benefícios é informativo e não deve ser somado uma segunda vez.
  const forecastTotal = manualTotal + hrMonthlyCost + maintenanceTotal;

  replaceText(hrValue, formatCurrency(hrMonthlyCost));
  replaceText(benefitsValue, formatCurrency(benefitsMonthlyCost));
  replaceText(totalValue, formatCurrency(forecastTotal));
};
